import MediaCard from "../../../Layouts/MediaCard/MediaCard";
import "./NMReports.css";
import Navbar from "../../../Partials/Navbar/Navbar";

function NMReports() {
  const reports = [
    {
      id: "1",
      img: "https://moddin.com/wp-content/uploads/2025/11/Bangladesh-Progress-Revised.webp",
      date: "2024-10-10",
      tag: "Nation Branding",
      name: "Bangladesh Benchmarking Garment Industry Progress",
      link: "https://moddin.com/wp-content/uploads/2025/11/Bangladesh-Report.pdf",
    },
    {
      id: "2",
      img: "https://moddin.com/wp-content/uploads/2025/11/Post-Event-Report-Circularity.jpg",
      date: "2024-06-11",
      tag: "Circularity",
      name: "Fashion, Circular Economy & Bangladesh",
      link: "https://moddin.com/wp-content/uploads/2025/11/Circularity-Report.pdf",
    },
  ];

  return (
    <div>
      <Navbar />
      <div className="reports_gallery">
        <div className="container_fluid container">
          <h1>Reports</h1>
          <div className="nm_reports">
            {reports?.map((report) => (
              <MediaCard
                key={report.id}
                img={report.img}
                date={report?.date}
                tag={report?.tag}
                name={report?.name}
                link={report?.link}
              />
            ))}
          </div>

          <div className="nm_reports_small">
            {reports?.map((report) => (
              <MediaCard
                key={report.id}
                img={report.img}
                date={report?.date}
                tag={report?.tag}
                name={report?.name}
                link={report?.link}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NMReports;
